import React from 'react';
import SkeletonBone from './SkeletonBone';
import './loading.css';

const SkeletonCard = () => (
  <article className="skeleton-card" aria-hidden="true">
    <SkeletonBone className="skeleton-card__image" style={{ borderRadius: 0 }} />
    <div className="skeleton-card__body">
      <SkeletonBone className="skeleton-card__title" />
      <SkeletonBone className="skeleton-card__meta" />
      <div className="skeleton-card__features">
        <SkeletonBone className="skeleton-card__feature" pill />
        <SkeletonBone className="skeleton-card__feature" pill />
        <SkeletonBone className="skeleton-card__feature" pill />
      </div>
      <SkeletonBone className="skeleton-card__price" />
    </div>
  </article>
);

export default SkeletonCard;
